module.exports = __webpack_public_path__ + "img/NewsCenterDetails3_pic3.f53a963c.png";